import isObject from "./is-object";

type InverseExclude<T, U> = T extends U ? T : never;

const isEmpty = <T extends unknown>(
  value: T
): value is InverseExclude<typeof value, undefined> => {
  if (value === null || !value) {
    return true;
  }

  if (Array.isArray(value)) {
    return value.length > 0 ? false : true;
  }

  if (isObject(value)) {
    // skip enumareting objects like date with million properties
    if (Object.getPrototypeOf(value) !== Object.prototype) {
      return true;
    }

    for (var prop in value) {
      if (value.hasOwnProperty(prop)) return false;
    }

    return true;
  }

  return false;
};

export default isEmpty;
